export const contentTableConfig = {
  title: '客户列表',
  propList: [
    {
      prop: 'nickName',
      label: '客户',
      minWidth: '80',
      slotName: 'consumer',
      align: 'left'
    },
    { prop: 'belongDeptName', label: '所属部门', minWidth: '80' },
    { prop: 'belongEmpName', label: '所属员工', minWidth: '80' },
    // { prop: 'empTag', label: '员工标签', minWidth: '70' },
    // { prop: 'typeName', label: '标签', minWidth: '80', slotName: 'typeName' },
    // { prop: 'transactionTime', label: '成交时间', minWidth: '100' },
    // { prop: 'dealDeptName', label: '成交部门', minWidth: '80' },
    // { prop: 'dealEmpName', label: '成交员工', minWidth: '80' },
    { prop: 'channelName', label: '来源渠道', minWidth: '100' },
    { prop: 'createdTime', label: '创建时间', minWidth: '100' },
    { prop: 'access', label: '访问记录', minWidth: '80', slotName: 'access' }
    // {
    //   label: '操作',
    //   minWidth: '60',
    //   slotName: 'handler'
    // }
  ],
  showSelectColumn: false
}
